import React from 'react';
import { Box, Typography, Chip } from '@mui/material';
import { getEventStatus, formatTime } from './eventUtils';

const STATUS_CONFIG = {
  active: { label: 'Nu bezig', color: 'success', bg: 'rgba(76, 175, 80, 0.1)' },
  past: { label: 'Afgelopen', color: 'default', bg: 'transparent' },
  upcoming: { label: 'Later', color: 'primary', bg: 'transparent' },
};

const EventRow = ({ event }) => {
  const status = getEventStatus(event);
  const config = STATUS_CONFIG[status];

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        p: 2,
        borderLeft: '4px solid',
        borderLeftColor: status === 'active' ? 'success.main' : 'transparent',
        bgcolor: config.bg,
        opacity: status === 'past' ? 0.6 : 1,
      }}
    >
      <Box sx={{ minWidth: 110 }}>
        <Typography variant="body2" color="text.secondary">
          {formatTime(event.start_time)} - {formatTime(event.end_time)}
        </Typography>
      </Box>
      <Box sx={{ flexGrow: 1 }}>
        <Typography variant="subtitle1" sx={{ fontWeight: status === 'active' ? 700 : 500 }}>
          {event.name || 'Naamloze sessie'}
        </Typography>
        {event.description && (
          <Typography variant="body2" color="text.secondary">
            {event.description}
          </Typography>
        )}
      </Box>
      <Chip label={config.label} color={config.color} size="small" />
    </Box>
  );
};

export default EventRow;
